import React, { Fragment } from 'react';
import DataDeleteLog from './DataDeleteLog';

const DeletionLog = () => {
    return (
        <Fragment>
            <DataDeleteLog />
        </Fragment>
    );
};

export default DeletionLog;
